import { createEpic } from "../helpers";

import {
	getPointsAdditionalAsyncAction,
	getPointsAdditionalListAsyncAction,
	postPointsAdditionalAsyncAction,
	updatePointsAdditionalAsyncAction,
	deletePointsAdditionalByIdAsyncAction,
} from "./pointsActions";

export const getPointsAdditionalListEpic = createEpic(
	getPointsAdditionalListAsyncAction,
	"points",
	"getPointsAdditionalList",
	true
);

export const postPointsAdditionalEpic = createEpic(
	postPointsAdditionalAsyncAction,
	"points",
	"postPointsAdditional",
	true
);

export const deletePointsAdditionalByIdEpic = createEpic(
	deletePointsAdditionalByIdAsyncAction,
	"points",
	"deletePointsAdditionalById",
	true
);

export const updatePointsAdditionalEpic = createEpic(
	updatePointsAdditionalAsyncAction,
	"points",
	"updatePointsAdditional",
	true
);

export const getPointsAdditionalEpic = createEpic(
	getPointsAdditionalAsyncAction,
	"points",
	"getPointsAdditional",
	true
);
